<div class="container">
    <div class="row">
        <div class="col-7 mb-1">
            <h3 i18n>Listado de operadores</h3>
        </div>
        
        <div class="col-12 mb-2">
            <div class="row">
                <div class="col-sm-6 col-md-3">
                    <div class="form">
                        <label for="name" i18n>Nombre</label>
                        <input type="text" class="form-control" id="name" [(ngModel)]="filterRequest.name" (keypress)="onKeyPress($event)">
                    </div>
                </div>
                <div class="col-sm-6 col-md-2">
                    <div class="form">
                        <label for="level" i18n>Nivel</label>
                        <select id="level" class="form-select" [(ngModel)]="filterRequest.exceptions_profile" (ngModelChange)="filterChangedRequest()">
                            <option value=""></option>
                            <option value="level1" i18n>Nivel 1</option>
                            <option value="level2" i18n>Nivel 2</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6 col-md-2">
                    <div class="form">
                        <label for="poblation" i18n>Municipio</label>
                        <select id="poblation" class="form-select" [(ngModel)]="filterRequest.municipalities" (ngModelChange)="filterChangedRequest()">
                            <option value="">-----</option>
                            @for (municipality of municipalities; track municipality) {
                                <option value="{{municipality.municipality.municipalityName}}">{{municipality.municipality.municipalityName}}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="col-sm-3 col-md-2">
                    <div class="form">
                        <button type="button" class="btn btn-primary btn-filter"
                            (click)="filterChangedRequest()" i18n>Filtrar</button>
                    </div>
                </div>
                <div class="col-sm-1 col-md-1">
                    <div class="form">
                        <button type="button" class="btn btn-primary btn-filter"
                            (click)="clearFilters()" i18n>X</button>
                    </div>
                </div>
                <div class="col-sm-2 col-md-2">
                    <div class="form">
                        <button type="button" class="btn btn-success btn-filter"
                            (click)="goToNew()" i18n>Nuevo</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mb-3">
            <div class="table-responsive mb-3">
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" class="orderable" [ngClass]="{'ordered-asc': orderedField=='name' && orderedDirection == 'asc', 'ordered-desc': orderedField=='name' && orderedDirection == 'desc'}" (click)="orderTable('name')" i18n>Nombre</th>
                            <th scope="col" class="orderable" [ngClass]="{'ordered-asc': orderedField=='exceptions_profile' && orderedDirection == 'asc', 'ordered-desc': orderedField=='exceptions_profile' && orderedDirection == 'desc'}" (click)="orderTable('exceptions_profile')" i18n>Nivel</th>
                            <th scope="col" class="orderable" [ngClass]="{'ordered-asc': orderedField=='municipalities' && orderedDirection == 'asc', 'ordered-desc': orderedField=='municipalities' && orderedDirection == 'desc'}" (click)="orderTable('municipalities')" i18n>Municipios</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (operator of operators; track operator.identifier) {
                        <tr class="clickable">
                            <td (click)="goToDetail(operator)">{{operator.name}}</td>
                            <td (click)="goToDetail(operator)">{{getLevelName(operator.exceptions_profile)}}</td>
                            <td (click)="goToDetail(operator)" >{{operator.municipalities ? operator.municipalities.join(', ') : ''}}</td>
                        </tr>
                        } @empty {
                        <tr>
                            <td colspan="9" class="text-center" i18n>No hay operadores</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>